import React from 'react';

const Team = () => {
    return ( 
        <h1>
            
        </h1>
     );
}
 
export default Team;